import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import {
  TrackingData,
  EventModule,
  EventFeature,
} from "../../../../utils/event-tracking/event-tracking.model";
import AgentProfileEditMainPage from "../../../agent-profile/pages/profile-main/AgentProfileEditMainPage";
import { eventTrackingService } from "../../../../utils/event-tracking/event-tracking.service";
import { localeMapToBackend } from "../../../agent-profile/utils/locale-utils";
import { AgentProfileItem, AwardItem, DncRedirectTargetEnum, StatusEnum } from "../../../agent-profile/types/agent-profile-types";
import { fetchAgentProfile, fetchSaveContact } from "../../../agent-profile/network/agentProfileCrud";
import { NOT_FOUND_ERROR_PAGE_PATH } from "../../../../routes/constants";
import { getDncNotFoundRedirectUrl } from "../../constants";

// eventTrackingService
export const DigitalNameCardScreen: React.FC = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const enableTracking = !(queryParams.get("preview") == 'true');

  const { refId } = useParams<{ refId: string }>();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { t, i18n } = useTranslation();
  const lang = i18n.language;
  let mappedLocale = localeMapToBackend[lang] || lang;
  let redirect = getDncNotFoundRedirectUrl(lang);

  const [agentProfile, setAgentProfile] = useState<AgentProfileItem>();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const reloadData = async () => {
    if (refId) {
      setIsLoading(true);
      try {
        const res = await fetchAgentProfile(refId, mappedLocale, dispatch, 'false');
        setAgentProfile(res);
      } catch (err) {
        if (redirect) {
          window.location.href = redirect;
        } else {
          navigate(NOT_FOUND_ERROR_PAGE_PATH);
        }
      } finally {
        setIsLoading(false);
      }
    }
  };

  const sendRedirectTracking = (feature: EventFeature) => {
    eventTrackingService.redirectReport(refId, enableTracking, {
      name: "dnc::entry",
      module: EventModule.dnc,
      feature: feature,
      journey: "default"
    } as TrackingData);
  }

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [refId, i18n.language]);

  if (isLoading || !agentProfile) {
    return (
      <>
      </>
    );
  } else {
    if (agentProfile.status != StatusEnum.ACTIVE || agentProfile.digitalNameCard?.enable != '1') {
      if (redirect) {
        window.location.href = redirect;
      } else {
        navigate(NOT_FOUND_ERROR_PAGE_PATH);
      }
      return (
        <>
        </>
      );
    }

    let phone: any = agentProfile?.agentDetail?.phone?.mobile ?? "";
    phone = phone ? phone.replaceAll("+", "").replaceAll(" ", "") : "";

    switch (agentProfile.digitalNameCard?.redirectTarget) {
      case DncRedirectTargetEnum.eprofile:
        sendRedirectTracking(EventFeature.eprofile);
        return <AgentProfileEditMainPage
          name="dnc::view_profile"
          module={EventModule.dnc}
          feature={EventFeature.eprofile}
          journey="home"
        />;
      case DncRedirectTargetEnum.contact:
        sendRedirectTracking(EventFeature.contact);
        if (refId) {
          try {
            const contactUrl: string = fetchSaveContact(refId, dispatch);
            window.location.href = contactUrl;
          } catch (err) {
            console.log('Target contact: contact link not found');
            navigate(NOT_FOUND_ERROR_PAGE_PATH);
          }
        }
        break;
      case DncRedirectTargetEnum.whatsapp:
        sendRedirectTracking(EventFeature.whatsapp);
        if (phone) {
          window.location.href = `https://wa.me/${phone}`;
        } else {
          console.log('Target whatsapp: Phone No. not found');
        }
        break;
      case DncRedirectTargetEnum.phone:
        sendRedirectTracking(EventFeature.phone);
        if (phone) {
          window.location.href = `tel:${agentProfile.agentDetail.phone.mobile}`;
        } else {
          console.log('Target phone: Phone No. not found');
        }
        break;
      case DncRedirectTargetEnum.disable:
      default:
        if (redirect) {
          window.location.href = redirect;
        } else {
          navigate(NOT_FOUND_ERROR_PAGE_PATH);
        }
        break;
    }
  }
  return (
    <>
    </>
  );
}